import { atom } from 'jotai';
export const CLIENT_BUILD_VARIANT_QUERY = 'variant';
export const DEFAULT_CLIENT_BUILD_VARIANT = 'default';
export const DEFAULT_RENDER_CONFIG = {
    clientBuildVariant: DEFAULT_CLIENT_BUILD_VARIANT,
    enableStreamingSSR: false,
    enableSpaMode: true,
    disableInlineScripts: true,
    enableSSRStyleInline: true,
};
export const $RenderConfig = atom(DEFAULT_RENDER_CONFIG);
$RenderConfig.debugLabel = '$RenderConfig';
